import React, { Component } from 'react';
import DaysComponent from '../../../../../../components/Days';

/**
 * Days screen, for showing days config page.
 *
 * @extends React.Component
 */
class Days extends Component {
  render() {
    return (
      <DaysComponent />
    );
  }
}

export default Days;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Days/index.js